import PageWrapper from "../../components/common/PageWrapper";
import Header from "../../components/common/Header";
import BodyWrapper from "../../components/common/BodyWrapper";
import Footer from "../../components/common/Footer";
import Wrapper from "../../components/dashboard/dashboardPartials/Wrapper";
import MySubscriptions from "../../components/dashboard/dashboardPartials/MySubscriptions";
import MyOrders from "../../components/dashboard/dashboardPartials/MyOrders";
import ReviewForm from "../../components/dashboard/orderPartials/ReviewForm";

const OrderReviewPage = () => {
 const account = {
    stats: {
      mySubscriptions: "1",
      myOrders: "2",
    },
    subscriptions: [
      {
        id: 1,
        plan: "1 week",
        meals: ["breakfast", "lunch"],
        mealPreferance: "Non-vegeterian",
        status: "active",
        autoRenew: "1",
        unreturnedBoxes: "2",
        childDetails: {
          firstName: "Jhon",
          lastName: "Doe",
          age: "10",
          gender: "boy",
        },
      },
      {
        id: 2,
        plan: "2 weeks",
        meals: ["breakfast"],
        mealPreferance: "Vegeterian",
        status: "paused",
        autoRenew: "0",
        unreturnedBoxes: "",
        childDetails: {
          firstName: "Sarah",
          lastName: "Rose",
          age: "8",
          gender: "girl",
        },
      },
    ],
    orders: [
      {
        id: "ORD98765",
        products: [
          {
            title: "Lunch Box",
            price: 100,
            image: require("../../assets/images/order1.png"),
          },
        ],
           totalAmount:500,
        orderDate: "09/Sep/2025",
        deliveryStatus: "pending",
      },
      {
        id: "ORD98766",
        products: [
          {
            title: "Water Bottle",
            price: 50,
            image: require("../../assets/images/order2.png"),
          },
          {
            title: "Mug",
            price: 30,
            image: require("../../assets/images/order2.png"),
          },
          {
            title: "Lunch Box",
            price: 100,
            image: require("../../assets/images/order2.png"),
          },
          {
            title: "School Bag",
            price: 200,
            image: require("../../assets/images/order2.png"),
          },
        ],
        totalAmount:500,
        orderDate: "09/Sep/2025",
        deliveryStatus: "delivered",
      },
    ],
    user: {
      firstName: "Abhirami",
      lastName: "Susith",
      photo:
        "https://plus.unsplash.com/premium_photo-1688350808212-4e6908a03925?q=80&w=1169&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
    notifications: [
      {
        title: "Subscription Successful",
        createdAt: "",
      },
    ],
  };
  const page = {
    promoCode: [
      { title: "50% OFF with code", code: "SchoolsBack" },
      { title: "20% OFF with code", code: "FirstOrder" },
    ],
  };
  const order = {
    id: "ORD98765",
    date: "2025-10-09",
    totalAmount: 799,
    status: "Delivered", // Pending, Shipped, Delivered, Cancelled, Returned
    paymentMethod: "UPI", // Card, UPI, Wallet, Cash
    paymentStatus: "Paid", // Paid, Unpaid, Refunded
    invoiceUrl: "/invoices/ORD98765.pdf",
    products: [
      {
        name: "Insulated Stainless Steel Water Bottle",
        image:
          "https://www.themessycorner.in/cdn/shop/files/IMG_3208_700x.jpg?v=1735897457", // replace with actual image path
        quantity: 1,
        price: 799,
        variant: "Color: Blue, Size: 1L",
      },
      {
        name: "Insulated Stainless Steel Water Bottle",
        image:
          "https://www.themessycorner.in/cdn/shop/products/P4_700x.jpg?v=1674215518", // replace with actual image path
        quantity: 1,
        price: 799,
        variant: "Color: peach, Size: 1L",
      },
    ],
    eta: "Oct 15, 2025",
    deliveryAddress: "45 Park Street, Dubai, UAE",
    deliveryStatus: "Delivered to doorstep",
  };
  return (
    <>
      {/* <FullScreenLoading /> */}
      <PageWrapper loading={false} className="bg-bg min-h-screen">
        <Header code={page.promoCode} />

        <BodyWrapper className="mb-0 xl:mb-0">
          <Wrapper goBack={true} component={<ReviewForm order={order} />} account={account} />
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default OrderReviewPage;
